module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_desktop-bc6797bf89e408cd88753355ed6e6e84.webp";